import React from "react";

import * as S from "./styles";

export const Slide2: React.FC = () => {
  return (
    <S.Container>
      <S.Content>
        <S.Photo className="photo" />
      </S.Content>
      <S.Content className="right">
        <S.Photo2></S.Photo2>
      </S.Content>
      <S.Credit>Blazer, R$ 2.277, e calça, R$ 1.127, ambos Printing.</S.Credit>
    </S.Container>
  );
};
